export const SHARED_MEMORY_FIELD = '_containerDeploySharedMemory';
